"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reportingMessage_1 = require("../reportingMessage");
var linkButton_1 = require("@vidazoo/ui/lib/components/linkButton");
exports.default = (function (_a) {
    var onOfflineReportButtonClick = _a.onOfflineReportButtonClick;
    return (React.createElement(reportingMessage_1.default, { iconName: "icon-no-results", title: "The requested report is too big", message: React.createElement("div", { className: "flex justify-center align-baseline" },
            "Try adding some filters ",
            onOfflineReportButtonClick ? (React.createElement("span", { className: "flex justify-center align-baseline" },
                "or",
                React.createElement(linkButton_1.LinkButton, { onClick: onOfflineReportButtonClick, blue: true, style: { marginLeft: 5 } }, "create offline report"))) : null) }));
});
